import React from 'react';
import * as PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToggleFeaturedMenuItem } from 'components/context-menu/toggle-featured-menu-item';
import { isAdminUser } from 'utils/common';
import { channelsSelector } from 'common/selectors/channels';
import { SimpleDropDown } from 'components/simple-dropdown/index';
import { ReportVideo } from 'components/video-box/common/report-video';
import { viewRangeSelector, withReportVideoSelector } from 'common/selectors';
import { MarkUnmarkAsStartVideoItemDecorated } from '../../pages/channel.page/fragments/mark-unmark-as-start-video-item';
import { MarkUnmarkStartHomeVideoDecorated } from 'components/mark-unmark-start-home-video/index';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

const featuredVideo = (video, channelId, pageNumber, channels) => {
  const channel = channels.find((c) => c.id === +channelId);
  return {
    ...video,
    featured: !!(channel && channel.featuredVideosId.includes(video.id)),
    currentChannel: channelId,
    pageNumber,
  };
};

const mapStateToProps = (state) => ({
  channels: channelsSelector(state),
  withReportVideo: withReportVideoSelector(state),
  viewRange: viewRangeSelector(state),
});

const VideoContextMenu = ({
  video,
  sort,
  match: {
    params: { channelId, pageNumber },
  },
  channels,
  withReportVideo,
  viewRange,
  testPrefix,
  className,
}) => {
  const showVideoActionMenu = isAdminUser() || withReportVideo;
  const { t } = useTranslation();

  return (
    showVideoActionMenu && (
      <SimpleDropDown
        icon={faEllipsisV}
        data-e2e={`${testPrefix || ''}video-actions-context-menu`}
        className={className}
        aria-label={t('video-actions-menu')}
      >
        {isAdminUser() && (
          <>
            <ToggleFeaturedMenuItem
              video={featuredVideo(video, channelId, +pageNumber, channels)}
              pageNumber={+pageNumber}
              sort={sort}
            />
            <MarkUnmarkAsStartVideoItemDecorated video={video} />
            <MarkUnmarkStartHomeVideoDecorated video={video} />
          </>
        )}
        {withReportVideo && <ReportVideo video={video} />}
      </SimpleDropDown>
    )
  );
};

export const VideoContextMenuDecorated = compose(withRouter, connect(mapStateToProps))(VideoContextMenu);

VideoContextMenuDecorated.propTypes = {
  video: PropTypes.object.isRequired,
  testPrefix: PropTypes.string,
};
